import { createSelector } from '@reduxjs/toolkit';

import {
  selectAccountCreateInProgress,
  selectActiveAccount,
  selectPaymentMethod,
} from '@cashier/cashier-data-access';
import { InputPreprocessors } from '@cashier/cashier-model';

import { FinteqHubService, PliromyService } from '../helpers';

export const selectActiveInputs = createSelector(
  selectPaymentMethod,
  selectAccountCreateInProgress,
  selectActiveAccount,
  (method, isInProgress, account) => {
    const { show_account_form, inputs, account_form_inputs } = method;
    const showMethodInputs = isInProgress || !account || !show_account_form;

    switch (method.preprocessor?.type) {
      case InputPreprocessors.PLIROMY_TOKENIZER:
        return PliromyService.enrichInputsWithCardItems(
          method,
          showMethodInputs,
        );
      case InputPreprocessors.FINTEQ_HUB_CARD_DEPOSIT:
        return FinteqHubService.enrichInputsWithCardItems(
          method,
          showMethodInputs,
        );
      default:
        return showMethodInputs ? inputs : account_form_inputs;
    }
  },
);
